import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const CustomTooltip = ({ title, position = 'top', children, maxWidth = 230, ...props }) => {
  return (
    <Tippy content={title} placement={position} maxWidth={`${maxWidth}px`} {...props}>
      <span>{children}</span>
    </Tippy>
  );
};

export default CustomTooltip;
